export const Types = {
  REQUEST: '@termsAndPolicy/REQUEST',
  SUCCESS: '@termsAndPolicy/SUCCESS',
  FAILURE: '@termsAndPolicy/FAILURE',
};

export type userType = {
  id: number;
  name: string;
  cpf: string;
  email: string;
  firstAccess: boolean;
  firstDashboardAccess: boolean;
  cookieConsent: boolean;
  termoUsoUsuario: {
    linkTermoUso: string;
    linkPoliticaPrivacidade: string;
    dataLimiteAceite: string;
    intervaloNotificaUsuario: number;
    flagStatusAceite: boolean;
    dataAtualizacaoTermo: string;
  };
};

export type metaType = {
  onSuccess: Function;
  onFailure: Function;
};

type ReturnUpdate = {
  type: string;
  status: boolean;
  user: userType;
  meta: metaType;
};

export function updateTermsAndPolicy(
  status: boolean,
  user: userType,
  onSuccess: Function,
  onFailure: Function,
): ReturnUpdate {
  return {
    type: Types.REQUEST,
    status,
    user,
    meta: { onSuccess, onFailure },
  };
}

export function termsAndPolicyFailure(error: Object) {
  return {
    type: Types.FAILURE,
    error,
  };
}
